import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    '& .ant-modal-header': {
      padding: '32px 20px 16px 60px',
    },

    '& .ant-modal-body': {
      padding: '0 60px',
    },
  },

  confirmWrapper: {
    '& .ant-modal-header': {
      padding: '32px 20px 16px 60px',
    },
    '& .ant-modal-body': {
      padding: '0 60px 32px 60px',
    },
  },

  subTitle: {
    ...theme.typography.h5,
    fontWeight: 'normal',
    color: theme.colors.bodyColor,
    marginBottom: 16,
  },

  settings: {
    marginTop: 24,

    '& h3': {
      position: 'relative',
      ...theme.typography.h4,
      paddingLeft: 12,
      marginBottom: 12,

      '&:before': {
        content: "''",
        position: 'absolute',
        width: 4,
        height: 16,
        backgroundColor: theme.colors.mainGreen6,
        left: 0,
        top: 4,
      },
    },

    '& .ant-form-item-label': {
      marginBottom: 8,
      lineHeight: '22px',
    },

    '& .ant-select-selection-selected-value span': {
      fontWeight: 'normal',
    },

    '& .ant-form-item-required::before': {
      display: 'none',
    },

    '& .ant-input-disabled, & .ant-calendar-picker-input, & .ant-select, & .ant-input': {
      color: theme.colors.titleColor,
    },

    '& .ant-input-group-addon': {
      textTransform: 'capitalize',
    },
  },
  roomName: {
    ...theme.typography.body2,
    color: theme.colors.titleColor,
  },
  roomCategory: {
    ...theme.typography.body4,
    color: theme.colors.captionColor,
    paddingLeft: 12,
  },
  roomOptionExtra: {
    height: 32,
    paddingLeft: 12,
    paddingTop: 5,
    ...theme.typography.body2,
    color: theme.colors.captionColor,

    '& > span': {
      color: theme.colors.mainGreen6,
      cursor: 'pointer',
    },
  },
  propertyName: {
    color: theme.colors.captionColor,
  },
  listing: {
    '& .ant-select-selection--single': {
      height: 52,
    },
    '& .ant-select-selection__rendered': {
      lineHeight: '52px',
    },
  },
  listingInfo: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  listingDropdown: {
    '& .ant-select-dropdown-menu-item': {
      padding: '10px 12px',
    },
  },
  listingSpan: {
    ...theme.typography.body2,
    color: theme.colors.titleColor,
    padding: '4px 8px',
    backgroundColor: theme.colors.gray3,
  },
  listingDate: {
    width: 216,
    ...theme.typography.body2,
    color: theme.colors.titleColor,
  },
  listingTenancy: {
    // width: 128,
  },
  listingPrice: {
    ...theme.typography.body2,
    color: theme.colors.titleColor,
  },
  listingDivider: {
    color: '#E7E7E7',
    padding: '0 16px',
  },
  listingBillingCycle: {
    ...theme.typography.body4,
    color: theme.colors.captionColor,
    paddingLeft: 4,
  },
  listingAvailability: {
    position: 'relative',
    ...theme.typography.body2,
    color: theme.colors.titleColor,
    paddingLeft: 14,

    '&:before': {
      content: "''",
      position: 'absolute',
      top: 8,
      left: 0,
      width: 6,
      height: 6,
      borderRadius: '100%',
    },

    '&.good:before': {
      background: '#33d16b',
    },

    '&.limited:before': {
      background: '#ea2d00',
    },
  },
  alertWarning: {
    marginBottom: 24,
    paddingRight: 12,
    paddingLeft: 28,
    border: '0 !important',

    '& .ant-alert-icon': {
      left: 12,
    },

    '& svg': {
      width: 12,
      height: 12,
      marginTop: 1,
    },

    '& p': {
      margin: 0,
    },

    '& .ant-alert-message': {
      color: theme.colors.orange6,
      ...theme.typography.body4,
    },
  },
  warningDate: {
    color: theme.colors.captionColor,
  },
  okButton: {
    marginLeft: 16,
    '& span': {
      fontWeight: '600 !important',
    },
  },
  cancelButton: {
    color: `${theme.colors.bodyColor} !important`,
    borderColor: `${theme.colors.gray5} !important`,
  },
  labelWithNum: {
    display: 'inline-block',
  },
  labelNum: {
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.45)',
    height: 20,
    width: 20,
    borderRadius: 20,
    backgroundColor: theme.colors.gray3,
    marginRight: 8,
    display: 'inline-block',
    textAlign: 'center',
  },
  divider: {
    padding: '0 16px',
    width: '100%',

    '& > .ant-divider': {
      marginTop: 0,
      marginBottom: 23,
    },
  },
}));

export default useStyles;
